
import ScrollToTop from '../components/ScrollToTop';
import React from 'react';
import GroupTourPackages from './GroupTourPackages';
const PopularDestination = React.lazy(() => import("../components/PopularDestination"));
const DomesticPackages = React.lazy(() => import("../components/DomesticPackages"));
const InternationalPackages = React.lazy(() => import("../components/InternationalPackages"));
const CustomerReviews = React.lazy(() => import("../components/CustomerReviews"));
const CallToAction = React.lazy(() => import("./CallToAction"));

const HomePage = () => {

    return (
        <>
            <main role='main'>
                <PopularDestination />
                <GroupTourPackages />
                <DomesticPackages />
                <InternationalPackages />
                <CustomerReviews />
                <CallToAction />
                {/* <!-- Back to Top --> */}
                <ScrollToTop />
            </main>
        </>
    );
};

export default HomePage;
